export default {
  title: 'Chat',
  description: 'Message individual crew members or a group, share photos and files, and see replies as they come in.',
  conversations: 'Conversations',
  conversation: 'Conversation',
  live: 'Live',
  noMessagesYet: 'No messages yet',
  emptyList: 'No conversations yet. Start one with a crew member.',
  chooseConversation: 'Choose a conversation, or start a new one.',

  // New conversation
  newConversation: 'New conversation',
  type: 'Type',
  direct: 'Direct',
  group: 'Group',
  groupName: 'Group name',
  groupNamePlaceholder: 'e.g. Barangaroo crew',
  siteOptional: 'Site (optional)',
  globalAllSites: 'Global (all sites)',
  messageWith: 'Message with',
  addPeople: 'Add people',
  creating: 'Creating…',
  startConversation: 'Start conversation',

  // Messages
  openPhoto: 'Open photo',
  photo: '📷 Photo',
  cancelReply: 'Cancel reply',
  react: 'React',
  reply: 'Reply',
  forward: 'Forward',
  seen: 'Seen',
  sent: 'Sent',
  forwardMessage: 'Forward message',
  noOtherConversations: 'No other conversations to forward to.',
  groupTag: 'group',
  forwardedTo: 'Forwarded to {name}',
  conversationLower: 'conversation',
  send: 'Send',
  typingOne: '{name} is typing…',
  typingTwo: '{first} and {second} are typing…',
  typingMany: 'Several people are typing…',

  // Thread
  backToConversations: 'Back to conversations',
  peopleOne: '{count} person',
  peopleOther: '{count} people',
  managePeople: 'Manage people',
  emptyThread: 'No messages yet — say hello.',
  photoAttached: 'Photo attached · {width}×{height}',
  removePhoto: 'Remove photo',
  attachPhoto: 'Attach photo',
  captionPlaceholder: 'Add a caption (optional)…',
  messagePlaceholder: 'Write a message…',
  messagePlaceholderMention: 'Write a message — type @ to mention someone',
  attachFile: 'Attach a photo or file',
  removeAttachment: 'Remove attachment',
  dropToAttach: 'Drop to attach',
  mentionSomeone: 'Mention someone',
  download: 'Download',
  downloadFile: 'Download {name}',

  // Manage people
  inThisConversation: 'In this conversation',
  adminTag: 'admin',
  removeAdmin: 'Remove admin',
  makeAdmin: 'Make admin',
  leave: 'Leave',
  addSomeone: 'Add someone',
  loadEarlier: 'Load earlier messages',
  reviewTitle: 'Chat review',
  reviewDescription: 'Every conversation in your company, including ones you\'re not in. Search, read the full history and export it. Only admins can see this page.',
  reviewSearchLabel: 'Search messages',
  reviewSearchPlaceholder: 'Words in a message or group name',
  reviewPerson: 'Person',
  reviewAnyone: 'Anyone',
  reviewSite: 'Group site',
  reviewAnySite: 'Any',
  reviewFrom: 'From',
  reviewTo: 'To',
  reviewFiltered: 'Filtered',
  reviewNoMatches: 'No conversations match these filters.',
  reviewNoneYet: 'Nobody in your company has chatted yet.',
  reviewChoose: 'Choose a conversation to read its full history.',
  reviewMessagesOne: '{count} message',
  reviewMessagesOther: '{count} messages',
  reviewNoMessages: 'No messages',
  reviewThreadEmpty: 'This conversation has no messages.',
  reviewStart: 'Start of conversation · {date}',
  reviewExport: 'Export CSV',
  reviewReadOnly: 'Read-only. Participants aren\'t notified, but each time you open a conversation it\'s recorded.',
  reportsTab: 'Reports',
  reportsIntro: 'Messages people reported from the app. Remove a message to hide it from everyone in that chat, or dismiss the report to leave it up. Admins get an email about each new report.',
  reportsShowOpen: 'Open',
  reportsShowAll: 'All',
  reportsNoneOpen: 'No open reports. When someone reports a chat message, it shows up here.',
  reportsNone: 'Nobody has reported a chat message yet.',
  reportReasonHarassment: 'Harassment or bullying',
  reportReasonInappropriate: 'Inappropriate or offensive',
  reportReasonSpam: 'Spam',
  reportReasonOther: 'Something else',
  reportCount: 'Reported by {count} people',
  reportStatusRemoved: 'Removed by {name}',
  reportStatusDismissed: 'Dismissed by {name}',
  reportReportedBy: 'Reported by {name} · {when}',
  reportHasAttachment: 'Includes a photo or file.',
  reportDetails: 'Their note:',
  reportViewConversation: 'View conversation',
  reportDismiss: 'Dismiss',
  reportRemoveMessage: 'Remove message',
  reportRemoveTitle: 'Remove this message?',
  reportRemoveMessageConfirm: 'Everyone in the chat will see “This message was removed by an admin” instead of what {name} wrote. You can still read the original here.',
  reportRemovedToast: 'Message removed',
  reportDismissedToast: 'Report dismissed',
  reportRemovedBadge: 'Removed by an admin',
}
